// Copyright (c) 2022 by Move Closer

import { IRelatedService, ModuleContentResolver, ProductData } from '../../contexts'

import { logger } from '../../support'
import { resolveImage, resolveProduct } from '../resolvers'

import {
  UsageCalculatorModuleContent,
  UsageCalculatorModuleContentInput,
  UsageCalculatorProductData
} from './UsageCalculator.contracts'

/**
 * @author Agnieszka Zawadzka <agnieszka.zawadzka@movecloser.pl>
 */
export const resolveUsageCalculatorModuleContent: ModuleContentResolver<UsageCalculatorModuleContentInput, UsageCalculatorModuleContent> =
  async (
    input: UsageCalculatorModuleContentInput,
    relatedService: IRelatedService
  ): Promise<UsageCalculatorModuleContent> => {
    const products: UsageCalculatorModuleContent['products'] = {} as UsageCalculatorProductData
    let image: UsageCalculatorModuleContent['image'] | null = null

    if (input.products) {
      try {
        await Promise.all(input.products.map(async ({ key, related }) => {
          const resolvedProduct: ProductData | null = related ? await resolveProduct(related, relatedService, input.siteId ?? undefined) : null
          products[key] = resolvedProduct
          return resolvedProduct
        }))
      } catch (e) {
        logger(e, 'warn')
      }
    }

    if (input.image) {
      try {
        image = await resolveImage(input.image, relatedService)
      } catch (e) {
        logger(e, 'warn')
      }
    }

    return {
      ...input,
      image,
      products
    }
  }
